// extracted by mini-css-extract-plugin
export default {"container":"faceId_container__IuFIX"};